

import { SVGProps } from 'react';
import { twMerge } from 'tailwind-merge';

export default function PostBadge(props: Partial<SVGProps<any>>) {
  return (
<svg width="62" height="31" viewBox="0 0 62 31" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <path d="M56 0C59.3137 6.44256e-07 62 2.68629 62 6V25C62 28.3137 59.3137 31 56 31H10L0 15.5L10 0H56Z" fill="#AF57DD"></path>
</svg>
  )
}
